import React from 'react';
import { Layout as AntLayout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  DashboardOutlined,
  ShoppingOutlined,
  TeamOutlined,
  ShopOutlined,
  FileTextOutlined,
  InboxOutlined,
  BarChartOutlined,
  LogoutOutlined,
  HomeOutlined,
  DollarOutlined,
  SettingOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
  FileSearchOutlined
} from '@ant-design/icons';
import { logout } from '../store/slices/authSlice';

const { Header, Sider, Content } = AntLayout;

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '工作台'
    },
    {
      key: '/products',
      icon: <ShoppingOutlined />,
      label: '商品管理'
    },
    {
      key: '/customers',
      icon: <TeamOutlined />,
      label: '客户管理'
    },
    {
      key: '/suppliers',
      icon: <ShopOutlined />,
      label: '供应商管理'
    },
    {
      key: 'orders',
      icon: <FileTextOutlined />,
      label: '订单管理',
      children: [
        {
          key: '/sales-orders',
          label: '销售订单'
        },
        {
          key: '/purchase-orders',
          label: '采购订单'
        }
      ]
    },
    {
      key: 'inventory-menu',
      icon: <InboxOutlined />,
      label: '库存管理',
      children: [
        {
          key: '/inventory',
          label: '库存查询'
        },
        {
          key: '/warehouses',
          icon: <HomeOutlined />,
          label: '仓库管理'
        }
      ]
    },
    {
      key: 'finance',
      icon: <DollarOutlined />,
      label: '财务管理',
      children: [
        {
          key: '/finance/receivables',
          label: '应收账款'
        },
        {
          key: '/finance/payables',
          label: '应付账款'
        },
        {
          key: '/finance/payments',
          label: '收付款记录'
        }
      ]
    },
    {
      key: '/reports',
      icon: <BarChartOutlined />,
      label: '报表分析'
    },
    {
      key: 'system',
      icon: <SettingOutlined />,
      label: '系统管理',
      children: [
        {
          key: '/system/users',
          icon: <UserOutlined />,
          label: '用户管理'
        },
        {
          key: '/system/roles',
          icon: <SafetyCertificateOutlined />,
          label: '角色权限'
        },
        {
          key: '/system/logs',
          icon: <FileSearchOutlined />,
          label: '操作日志'
        }
      ]
    }
  ];

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0
        }}
      >
        <div className="logo" style={{ padding: '16px', color: 'white', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
          五金刀具ERP
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <AntLayout style={{ marginLeft: 200 }}>
        <Header style={{ 
          background: '#fff', 
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 1px 4px rgba(0,21,41,.08)'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 500 }}>
            欢迎, {user?.realName || user?.username}
          </div>
          <div>
            <span style={{ marginRight: 16, color: '#999' }}>
              角色: {user?.role}
            </span>
            <LogoutOutlined 
              onClick={handleLogout}
              style={{ fontSize: 16, cursor: 'pointer' }}
            />
          </div>
        </Header>
        <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
          <div className="site-layout-content">
            {children}
          </div>
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
